import { memo } from "react";
import { Grid2, Typography } from "@mui/material";

interface InfoRowProps {
    title: string;
    content: string | null | undefined;
    monospace?: boolean;
}

const InfoRow = memo(({ title, content, monospace }: InfoRowProps) => {
    return (
        <Grid2 container size={12}>
            <Grid2 size={"grow"}>
                <Typography variant={"body2"} fontWeight={500}>
                    {title}:
                </Typography>
            </Grid2>

            <Grid2>
                <Typography variant={"body2"} sx={{ fontFamily: monospace ? "monospace" : undefined }}>
                    {content ?? "not available"}
                </Typography>
            </Grid2>
        </Grid2>
    );
});

export default InfoRow;
